module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absence-sidebar text-dark"
  }, [_c('div', {
    staticClass: "absence-sidebar__header"
  }, [_c('div', {
    staticClass: "absence-sidebar__header__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.i18n['absent_on_date']))])]), _vm._v(" "), _c('div', {
    staticClass: "absence-sidebar__date-nav"
  }, [_c('button', {
    staticClass: "date-buttons",
    on: {
      "click": _vm.prevDay
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  })]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.selectedDate,
      "width100": true
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "date-buttons",
    on: {
      "click": _vm.nextDay
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right4"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "absence-sidebar__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "absence-sidebar__spinner"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : (_vm.absentUsers.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n['no_one_absent']))]) : _c('ul', _vm._l((_vm.absentUsers), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "absent-user shadow",
      class: {
        'absent-user--requester': user.isRequester
      }
    }, [_c('div', {
      staticClass: "absent-user__name"
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._l((user.absence), function(absence, idx) {
      return _c('div', {
        key: idx,
        staticClass: "absent-user__absence"
      }, [_c('b', [_vm._v(_vm._s(absence.title))]), _vm._v(" "), _c('span', [_c('span', {
        staticClass: "icon-clock"
      }), _vm._v(" " + _vm._s(absence.timeRange))]), _vm._v(" "), (absence.dateRange) ? _c('span', [_c('span', {
        staticClass: "icon-calendar4"
      }), _vm._v(" " + _vm._s(absence.dateRange))]) : _vm._e()])
    })], 2)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8747714c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequestAbsenceSidebar.vue
// module id = 2052
// module chunks = 1